/**
 * Created by hao.cheng on 2017/4/16.
 */
import React from 'react';
import {Col,Row, Form, Icon, Input, Button, Checkbox, message } from 'antd';
import title from '@/style/imgs/all/title.png';
import feima from '@/style/imgs/all/feima.png';
import yidian from '@/style/imgs/all/yidian.png';
import BreadcrumbCustom from './BreadcrumbCustom';
const FormItem = Form.Item;

class Yjjy extends React.Component {
    state = {
        active:1,
        orderActive:"",
        title:"",

    };
    render() {
        return (
            <div className="content-right">
                <BreadcrumbCustom first="飞马救援"  second="一键救援"  />
                <div>
                        <Col>
                            <Col style={{width:"962px",paddingLeft:26,marginTop:46,height:850,background:"#fff",border:"1px solid #ccc"}}>
                                <Col style={{overflow:"hidden",paddingTop:46}}><img style={{float:"left",marginTop:6}} src={title} alt=""/><span style={{fontWeight:"bold",marginLeft:8,fontSize:18,color:"#282828",float:"left"}}>一键救援</span></Col>
                                <Col style={{height:70,marginTop:20,width:880,backgroundColor:"#eee",borderTop:"1px solid #ccc"}}>
                                    <span style={{fontSize:14,color:"#666",lineHeight:"70px",marginLeft:50}}>一点救援</span>
                                </Col>
                                <Col style={{marginLeft:15,marginTop:30}}>
                                    <span style={{marginLeft:15}}>可通过扫描下方二维码下载一点救援APP，进行自助发单</span>
                                    <Col style={{marginTop:16}}>
                                        <img style={{width:"198px"}} src={yidian} alt=""/>
                                    </Col>
                                </Col>
                                <Col style={{height:70,marginTop:20,width:880,backgroundColor:"#eee",borderTop:"1px solid #ccc"}}>
                                    <span style={{fontSize:14,color:"#666",lineHeight:"70px",marginLeft:50}}>飞马汽车救援微信公众号</span>
                                </Col>
                                <Col style={{marginLeft:15,marginTop:30}}>
                                    <span style={{marginLeft:15}}>可通过扫描下方二维码关注飞马汽车救援公众号进行下单</span>
                                    <Col style={{marginTop:16}}>
                                        <img style={{width:"198px"}} src={feima} alt=""/>
                                    </Col>
                                </Col>
                            </Col>
                        </Col>
                </div>
            </div>


        );
    }
}



export default Yjjy;


// WEBPACK FOOTER //
// ./src/components/yjjy.jsx